/**
 * Personel arayüzünün (HisApp) oturumunun nerede durduğunu bilen tek yer.
 *
 * Artık varsayılan yol ÇEREZ: token'ı sunucu HttpOnly `his_at` çerezine yazıyor, JavaScript onu
 * göremiyor (XSS ile çalınamaz). Uygulamanın "girişliyim" bilgisini yine de round-trip'siz bilmesi
 * gerektiği için sunucu yanına HttpOnly OLMAYAN bir işaret çerezi (`his_auth`) koyuyor — içinde sır
 * yok, yetkiyi her zaman HttpOnly olan taşıyor.
 *
 * localStorage'daki token KALDIRILMADI:
 *   - güncellemeden önce girmiş personelin elinde hâlâ geçerli token var; açılışta bir kez
 *     Auth/Session ile çereze taşınıyor, kimse yeniden giriş yapmak zorunda kalmıyor,
 *   - HASTA uygulaması (PatientApp) tamamen token'la çalışıyor: girişi SMS linkindeki
 *     ?access_token= ile oluyor ve sunucu hasta token'ı için çerez KURMUYOR. Bu dosya personel
 *     tarafınındır; hasta akışı PatientLocalStorage üzerinden eskisi gibi sürer.
 */

const HINT_COOKIE = 'his_auth';

/** Sunucunun kurduğu işaret çerezi duruyor mu? */
function hasCookieSession() {
    return document.cookie
        .split('; ')
        .some(item => {
            const [name, ...rest] = item.split('=');
            return name === HINT_COOKIE && rest.join('=') !== '';
        });
}

export const SessionService = {
    hasCookieSession,
};
